import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
     .module('oddCampaignModule')
     .controller('oddCampaignSummarySurveyController', Controller);

    Controller.$inject = ['$scope', '$modal', 'oddSurveyService', 'exportService'];

    function Controller($scope, $modal, oddSurveyService, exportService) {

        // Get Lookups
        oddSurveyService
            .getLookups()
            .then(function (lkups) {
                $scope.surveyLookups = lkups;
            })

        // Show Summary?
        $scope.showSummary = function () {
            return $scope.boxModel.HasResponses;
        }

      // Poll export
      $scope.pollExport = function (report) {
        exportService.pollExport(report.apiUrl, {
          reportType: report.ReportType,
          reportPath: report.ReportPath
        });
      };

        // Show Campaign Export?
        $scope.showCampaignExport = function () {
            if (!$scope.boxModel.ODDCampaignID) return false;
            if ($scope.boxModel._stateLoading) return false;
            if (!$scope.boxModel.ProgressState) return false;
            if ($scope.boxModel.ProgressState.Value !== 'Completed') return false;
            if (!$scope.boxModel.ProgressStatus) return false;

            return $scope.boxModel.ProgressStatus.Value === 'Draft' ||
                    $scope.boxModel.ProgressStatus.Value === 'Published';
        };

        // Open Export Reports Modal
        $scope.openExportReportsModal = function () {

            var buId = $scope.boxModel.ODDBusinessUnitID;
            var campId = $scope.boxModel.ODDCampaignID;
            var reportApiBaseUrl = environment.apiUrl + '/ReportPilot/API/SurveyV2/BusinessUnit/' + buId +
                                   '/Campaign/' + campId +
                                   '/Export/To/';

            // Modal to show
            var modalScope = $scope.$new(true);

            modalScope.boxModel = $scope.boxModel;
            modalScope.reports = _.map($scope.surveyLookups.ReportParams, function (report) {
                report.apiUrl = reportApiBaseUrl + report.ReportFormat;
                switch (report.ReportFormat) {
                  case 'DOCX':
                    report.ReportCssIcon = 'fa fa-file-word-o';
                    break;
                  case 'XLSX':
                    report.ReportCssIcon = 'fa fa-file-excel-o';
                    break;
                }
                return report;
            });

            modalScope.pollExport = $scope.pollExport;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/odd/campaign/summarySurveyExportReportsModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                showModal.$promise.then(showModal.hide);
            }

            modalScope.okModal = function () {
                modalScope.hideModal();
            }
        };
    }

})();
